import React, { useEffect } from "react";
import { loadRazorpayScript } from "../../functionsMaster";
import PropTypes from 'prop-types';

const RazorpayButton = ({
  formData = {},
  userData = {},
  confirmPayment = (v) => { console.log(v) }
}) => {
  const handlePayment = async () => {
    const res = await loadRazorpayScript();
    if (!res) {
      alert('Failed to load Razorpay SDK');
      return;
    }

    const orderRes = await fetch(`${process.env.REACT_APP_API_URL}external/makePayment`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ amount: formData.total }), // Amount in INR
    });
    let order = await orderRes.json();
    order = order.order;
    const token = localStorage.getItem('uToken');
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: order.amount,
      currency: 'INR',
      name: 'Namo Cars - Udaipur',
      description: 'Self Drive Car Provider',
      image: 'https://www.namocars.com/logo.png', 
      order_id: order.id,
      handler: async (response) => {
        const verifyRes = await fetch(`${process.env.REACT_APP_API_URL}bookings/createBooking`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Basic ${token}`,
          },
          body: JSON.stringify({ ...response, formData, userData }),
        });

        const verifyData = await verifyRes.json();
        confirmPayment(verifyData);
        // alert(verifyData.status === 'success' ? 'Payment Successful' : 'Payment Failed');
      },
      prefill: {
        name: userData.name,
        email: userData.email,
        contact: userData.mobile,
      },
      theme: {
        color: 'yellow',
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  useEffect(() => {
    handlePayment();
  }, []); // ← empty dependency array = run once on mount

  return (
    <>Loading</>
  );
};

RazorpayButton.propTypes = {
  formData: PropTypes.any.isRequired,
  userData: PropTypes.any.isRequired,
  confirmPayment: PropTypes.func.isRequired,
};

export default RazorpayButton;
